webpackJsonp([4],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/projects.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---projects-586c7e095e534a3909ec.js